import { createIcon } from '@chakra-ui/react';

export const GazpromIcon = createIcon({
  displayName: 'GazpromIcon',
  viewBox: '0 0 94 34',
  path: (
    <>
      <g transform='translate(0 0) scale(0.60722)'>
        <path
          d='M30.74 10.113C29.5616 4.9166 26.6043 0.690114 26.1966 0C25.5555 0.96989 23.1949 4.70024 21.9979 8.84092C20.6897 13.4554 20.497 17.5513 20.9491 21.5838C21.3975 25.6163 23.0911 29.757 23.0911 29.757C23.9916 31.9355 25.3406 34.2632 26.2189 35.4085C27.5048 33.7261 30.4621 28.7013 31.3812 22.1433C31.8926 18.4988 31.9148 15.3093 30.74 10.1092V10.113ZM26.1966 34.114C25.6185 33.0136 24.718 30.9208 24.6328 27.6866C24.6105 24.5606 25.852 21.8859 26.2152 21.3264C26.5376 21.8859 27.6086 24.2174 27.7346 27.4069C27.8198 30.5329 26.7933 32.9912 26.1929 34.114H26.1966ZM30.3917 18.9315C30.3472 20.9123 30.1137 23.0051 29.8136 24.2584C29.921 22.1023 29.6653 19.0621 29.1725 16.6896C28.6796 14.3171 27.2862 10.3517 26.1744 8.51638C25.1479 10.2622 23.8805 13.6941 23.2171 16.6672C22.5501 19.644 22.5315 23.2438 22.5315 24.3256C22.3574 23.4154 21.9127 20.17 22.0387 16.9059C22.1424 14.2126 22.765 11.4484 23.1097 10.1764C24.4141 5.92752 25.8965 3.21183 26.1744 2.77911C26.4523 3.21183 28.3164 6.55422 29.2836 10.0682C30.2435 13.5822 30.4399 16.947 30.3954 18.9315'
          fill='#e9edefff'
        />
        <path
          d='M28.198 36.6209H19.2335V42.679C19.2335 42.679 19.2483 42.6603 19.2557 42.6529C21.3681 40.5266 24.7923 40.5266 26.9083 42.6529C29.0207 44.7792 29.0207 48.2297 26.9083 50.356C26.9009 50.3635 26.8898 50.371 26.8824 50.3821C26.8824 50.3821 26.8602 50.4008 26.8527 50.412C24.7478 52.5196 21.9943 53.5716 19.2409 53.5716C16.4874 53.5716 13.708 52.5084 11.5994 50.3859C7.88239 46.6443 7.44139 40.8511 10.2764 36.6209C10.6581 36.0502 11.0991 35.5055 11.5994 35.0019C13.708 32.8794 16.4763 31.8162 19.2409 31.8162V17.2529C8.61245 17.2529 0 25.926 0 36.6246C0 47.3233 8.61615 55.9926 19.2409 55.9926C24.7812 55.9926 29.773 53.635 33.2861 49.8599V36.6209H28.2091H28.198Z'
          fill='#eaeef0ff'
        />
      </g>
      <text
        x='27'
        y='25'
        fontFamily='Arial, Helvetica, sans-serif'
        fontSize='22'
        fontWeight='700'
        fill='#eaeef1ff'
      >
        ГПБ
      </text>
    </>
  ),
});
